import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiUsers, FiTrendingUp, FiShield } = FiIcons;

const WhyWorkWithUs = () => {
  const reasons = [
    {
      icon: FiAward,
      title: "Industry Leadership",
      description: "Work with a recognized leader in the insulation industry with over 15 years of excellence."
    },
    {
      icon: FiUsers,
      title: "Team Culture",
      description: "Join a supportive team environment that values collaboration, respect, and professional growth."
    },
    {
      icon: FiTrendingUp,
      title: "Career Growth",
      description: "Advance your career with comprehensive training programs and clear advancement opportunities."
    },
    {
      icon: FiShield,
      title: "Safety First",
      description: "Work in a safety-focused environment with industry-leading safety protocols and training."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-black text-black mb-6">
            Why Work With <span className="text-mag-blue">MAG Insulation</span>?
          </h2>
          <p className="text-xl text-black max-w-3xl mx-auto font-medium">
            Discover what makes MAG Insulation a great place to build your career in the construction and insulation industry.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center group"
            >
              <div className="w-20 h-20 bg-gray-50 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-mag-blue transition-colors duration-300 border border-gray-100">
                <SafeIcon icon={reason.icon} className="w-10 h-10 text-mag-blue group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-xl font-bold text-black mb-4">
                {reason.title}
              </h3>
              <p className="text-black leading-relaxed">
                {reason.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyWorkWithUs;